export class StorageService {
  loadFromStorage = (key: string): any => {
    try {
      const jsonValue = localStorage.getItem(key);
      return jsonValue != null ? JSON.parse(jsonValue) : null;
    } catch (e) {
      console.error(e);
    }
  };

  persistToStorage = (key: string, content: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(content));
    } catch (e) {
      console.error(e);
    }
  };
}
